export const FETCH_TICKETS_REQUEST = "FETCH_TICKETS_REQUEST";
export const FETCH_TICKET_MESSAGES_REQUEST = "FETCH_TICKET_MESSAGES_REQUEST";
export const SEND_TICKET_MESSAGE_REQUEST = "SEND_TICKET_MESSAGE_REQUEST";
export const CHANGE_DEPARTMENT_OR_STATUS_REQUEST = "CHANGE_DEPARTMENT_OR_STATUS_REQUEST";
export const DOWNLOAD_TICKET_DOCUMENT_REQUEST = "DOWNLOAD_TICKET_DOCUMENT_REQUEST";
export const SEND_TICKET_DOCUMENTS_REQUEST = "SEND_TICKET_DOCUMENTS_REQUEST";
export const GET_REJECTION_REASONS_REQUEST = "GET_REJECTION_REASONS_REQUEST";
export const UPDATE_TICKET_DOCUMENT_STATUS_REQUEST = "UPDATE_TICKET_DOCUMENT_STATUS_REQUEST";
export const TICKET_DOCUMENT_REJECTION_REASONS = "TICKET_DOCUMENT_REJECTION_REASONS";
